import React from 'react';
import { HStack } from '@adc/parallax-component-library';
const Image = ({ src, testID, alt = '', ...rest }) => {
    return (React.createElement(HStack, { testID: testID, ...rest },
        React.createElement("img", { src: src, alt: alt })));
};
export { Image };
